// Script / caption model for the Cold Compute / Neon series.
// Pure logic (unit-tested) — no React imports so it runs under ts-jest (node env).

export interface ScriptLine {
  /** Scene key this line belongs to (ties to the per-video SCENE map; informational). */
  scene: string;
  /** Scene-LOCAL start, in seconds (a scene renders inside its own <Sequence>). */
  fromSec: number;
  /** How long the caption stays on screen, seconds (default 3.2). */
  holdSec?: number;
  /** The on-screen caption == the spoken VO line. */
  caption: string;
}

export const DEFAULT_HOLD = 3.2;

/**
 * The active caption for a SCENE-LOCAL frame, with STICKY semantics: show the
 * most-recently-started line and keep it on screen until the NEXT line begins
 * (or the scene ends). `frame` is useCurrentFrame() inside the scene's <Sequence>.
 *
 * Why sticky: the display time of each caption becomes the gap to the next line
 * (the readable ~5-6s the scripts already use), and the LAST line never vanishes
 * early — it persists through the rest of the slide. `holdSec` is retained on the
 * type for the VO/timecode doc but no longer cuts a caption off mid-slide.
 *
 * Returns a 0- or 1-element array (callers map over it).
 */
export function activeLines(
  lines: ScriptLine[],
  frame: number,
  fps = 30,
): ScriptLine[] {
  const sec = frame / fps;
  let current: ScriptLine | null = null;
  for (const l of lines) {
    if (sec >= l.fromSec && (current === null || l.fromSec >= current.fromSec)) {
      current = l;
    }
  }
  return current ? [current] : [];
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
